import { DirectRegion } from '../../../types';

const VISIBLE_REGIONS = 2;

export const formatGeography = (geography: DirectRegion[]) => {
    if (geography.length <= VISIBLE_REGIONS) {
        return geography.map((geo) => geo.name).join(', ');
    }
    const visible = geography.slice(0, VISIBLE_REGIONS);
    const remaining = geography.length - VISIBLE_REGIONS;

    return `${visible.map((geo) => geo.name).join(', ')}... +${remaining}`;
};
